module.exports = __webpack_public_path__ + "static/media/shark.f18ec5e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/icons/shark.png
// module id = 103
// module chunks = 0